export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/96b5356497d7cf68de56da40f562938b.png";